/** Display serving time like preview (11:50) from API strings. */
export function formatServingTimeLabel(raw) {
	if (raw == null || raw === '') return '';
	const s = String(raw).trim();
	const match = s.match(/^(\d{1,2}):(\d{2})/);
	if (match) {
		const h = match[1].padStart(2, '0');
		return `${h}:${match[2]}`;
	}
	return s;
}
